// Copied from sumify
// https://github.com/Dooer/frontend-sumify-neue/blob/61bb3480c3d3420281d764419566a766f84e3370/src/lib/video-player.js
import { css } from 'glamor'
import React, { Component } from 'react'
import ReactPlayer from 'react-player'
import * as Sentry from '@sentry/browser'

import { Loader } from '@dooer/react-ui-kit'

const styles = {
  wrapper: {
    base: {
      width: '100%',
      height: 0,
      boxSizing: 'content-box',
      paddingBottom: '56.25%', // 16:9 ratio
      position: 'relative',
    },
  },
  player: {
    base: {
      width: '100%',
      height: '100%',
      position: 'absolute',
    },
    loading: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
}

const getVideoUrl = (video) => {
  const { __typename, id, url } = video

  switch (__typename) {
    case 'WistiaVideo':
      return url
    case 'YoutubeVideo':
      return `https://www.youtube.com/watch?v=${id}`
    default:
      Sentry.captureException(new Error(`Received unknown video type ${__typename}`))
  }
}

export default class VideoPlayer extends Component {
  state = {
    isReady: false,
    hasErrored: false,
  }

  handleReady = (...args) => {
    this.setState({ isReady: true })
    if (this.props.onReady) this.props.onReady(...args)
  }

  handleError = (...args) => {
    this.setState({ hasErrored: true })
    if (this.props.onError) this.props.onError(...args)
  }

  render() {
    const { video, ...props } = this.props

    if (!video) return null

    const url = getVideoUrl(video)
    const { hasErrored, isReady } = this.state

    return (
      <div {...css(styles.wrapper.base)}>
        {!isReady && !hasErrored && (
          <div {...css({ ...styles.player.base, ...styles.player.loading })}>
            <Loader />
          </div>
        )}
        <ReactPlayer
          {...props}
          height={styles.player.base.height}
          onError={this.handleError}
          onReady={this.handleReady}
          style={styles.player.base}
          url={url}
          width={styles.player.base.width}
        />
      </div>
    )
  }
}
